import {
  Chip as MaterialChip,
  IconButton as MateralIconbutton,
} from '@material-ui/core';
import styled, { css } from 'styled-components';

import colors from '../../styles/colors';

interface IconButtonProps {
  selected: boolean;
}

export const Container = styled.div`
  padding: 0px 0px 0px 10px;

  h1 {
    font-weight: normal;
    font-size: 24px;
    color: #4d4d4d;
    margin: 8px 0;
  }

  h2 {
    font-size: 14px;
    font-weight: normal;
    color: #808080;
    margin: 0;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      margin: 16px 0 40px 0;
    }
  }
  button {
    margin: 0px 0 10px 0;
  }
  ul {
    li {
      display: flex;
      align-items: center;
      margin: 0 10px 10px 0;
      border-bottom: 1px solid #e6e6e6;
      padding-bottom: 10px;
      cursor: pointer;

      div {
        flex: 1;
      }

      label {
        margin-left: 10px;
        flex: 1;
        cursor: pointer;
      }
      button {
        margin: 0;
        min-width: 28px;
        min-height: 28px;
        padding: 5px 5px;
      }
    }
  }
`;

export const ContainerInputSearch = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background: ${colors.white};
  border: 1px solid #e6e6e6;
  margin-bottom: 40px;
  border-radius: 5px;
  padding: 10px;
  font-size: 16px;

  > svg {
    margin-right: 5px;
    fill: ${colors.gray};
  }

  input {
    width: 100%;
    background: none;
    border: 0;

    &::placeholder {
      color: ${colors.gray};
    }
  }
`;

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  span:first-child {
    margin-right: 10px;
  }
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  min-height: 50px;
  padding: 15px;
  transition: border 0.3s;
  color: transparent;
  font-size: 0;
`;

export const ChipContainer = styled.div`
  flex: 1;
`;

export const Chip = styled(MaterialChip)`
  margin: 0 5px 5px 0;
  border-radius: 5px !important;
  background: none !important;
  border: 1px solid ${colors.primary} !important;

  svg {
    color: ${colors.primary} !important;
  }

  span {
    color: ${colors.darkgray};

    &:before {
      content: none;
    }
  }
`;

export const IconButton = styled(MateralIconbutton)<IconButtonProps>`
  border: 1px solid ${colors.primary} !important;
  padding: 3px !important;

  .MuiIconButton-label {
    color: transparent;
  }

  ${(props) =>
    props.selected &&
    css`
      background-color: ${colors.primary} !important;
      box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
        0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);

      .MuiIconButton-label {
        color: ${colors.white};
      }
    `}
`;

export const FooterContainer = styled.div`
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  background: white;
`;

export const ContentFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0;
  padding: 0;

  li {
    border-bottom: none !important;

    button {
      min-width: 32px !important;
    }
  }
`;

export const AddButton = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    margin: 20px 0 10px 0;
  }
`;
